<template>
  <div class="wrapper">
    <div class="registerCard">
      <el-card shadow="hover">
        <div class="mooctestlogo"></div>
        <div style="text-align: center">
          <!--          <span style="">{{$t('registerPage.welcome')}}</span>-->
          <!--          <el-button circle style="margin-left: 2px" type="text" @click="changeLang">中/Eng</el-button>-->
          <h2
            style="
              font-family:
                Helvetica Neue,
                Helvetica,
                Arial,
                sans-serif;
              margin-right: -2em;
            "
          >
            MOOCTEST
            <el-button circle type="text" @click="changeLang">中/Eng</el-button>
          </h2>
        </div>
        <!--        <br />-->
        <el-form
          @submit.native.prevent
          style="margin-top: 20px"
          :model="registerForm"
          ref="registerForm"
          label-position="right"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item :label="$t('registerPage.username')" prop="username">
            <el-input
              :placeholder="$t('registerPage.username')"
              v-model="registerForm.username"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('registerPage.email')" prop="email">
            <el-input
              :placeholder="$t('registerPage.email')"
              v-model="registerForm.email"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('registerPage.password')" prop="password">
            <el-input
              type="password"
              :placeholder="$t('registerPage.password')"
              v-model="registerForm.password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('registerPage.confirm')"
            prop="checkPassword"
          >
            <el-input
              type="password"
              :placeholder="$t('registerPage.inputPsdAgain')"
              v-model="registerForm.checkPassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <router-link to="login">
          <el-button
            type="primary"
            plain
            style="float: right; margin-bottom: 20px"
            >{{ $t("button.cancel") }}
          </el-button>
        </router-link>
        <el-button
          type="primary"
          style="float: right; margin-bottom: 20px; margin-right: 10px"
          @click="submitForm()"
          >{{ $t("registerPage.register") }}
        </el-button>
      </el-card>
    </div>
    <div
      style="
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: white;
        font-size: 20px;
        font-weight: 600;
      "
    >
      <p>版权所有： 南京慕测信息科技有限公司</p>
      <p>
        <a
          style="text-decoration: none; color: inherit"
          href="https://beian.miit.gov.cn/"
          >苏ICP备14002894号-3</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { register } from "../api/user";

export default {
  name: "registerPage",
  data() {
    return {
      registerForm: {
        password: "",
        username: "",
        email: "",
        checkPassword: "",
      },
    };
  },
  computed: {
    rules() {
      const that = this;
      const validatePass = (rule, value, callback) => {
        if (value.length > 16 || value.length < 6) {
          callback(
            new Error(that.$t("registerPage.psdLength", { s: 6, l: 16 })),
          );
        } else if (this.registerForm.checkPass !== "") {
          this.$refs.registerForm.validateField("checkPassword");
        }
        callback();
      };
      const validateUsername = (rule, value, callback) => {
        if (value.length > 16 || value.length < 2) {
          callback(
            new Error(that.$t("registerPage.nameLength", { s: 2, l: 16 })),
          );
        }
        callback();
      };
      const validatePass2 = (rule, value, callback) => {
        if (value !== this.registerForm.password) {
          callback(new Error(that.$t("registerPage.psdDiffer")));
        } else {
          callback();
        }
      };
      return {
        password: [
          { required: true, message: that.$t("common.notNull") },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          { required: true, message: that.$t("common.notNull") },
          { validator: validatePass2, trigger: "blur" },
        ],
        username: [
          { required: true, message: that.$t("common.notNull") },
          { validator: validateUsername, trigger: "blur" },
        ],
        email: [
          { required: true, message: that.$t("common.notNull") },
          { type: "email", message: that.$t("registerPage.emailFormat") },
        ],
      };
    },
  },
  methods: {
    submitForm() {
      this.$refs.registerForm.validate().then((valid) => {
        const that = this;
        if (valid) {
          // 表单验证成功后，开始登录
          register(
            this.registerForm.username,
            this.registerForm.email,
            this.registerForm.password,
          )
            .then((res) => {
              this.$notify({
                type: "success",
                title: that.$t("common.success"),
                duration: 3000,
              });
              localStorage.setItem("loginStatus", true);
              localStorage.setItem("uid", res.id);
              localStorage.setItem("email", res.email);
              this.$router.push({ name: "loginPage" });
            })
            .catch(() => {
              this.$notify({
                type: "error",
                title: that.$t("common.fail"),
                duration: 3000,
                message: that.$t("registerPage.userExist"),
              });
            });
        } else {
          // 表单验证部分，判断输入是否为空，此处可以优化，抽离方法，并抽象验证方式
          this.$notify({
            type: "warning",
            title: that.$t("common.error"),
            duration: 3000,
            message: that.$t("common.formatInfo"),
          });
        } // if
      }); // valid
    },
    changeLang() {
      if (this.$i18n.locale === "cn") {
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "cn";
        localStorage.setItem("lang", "cn");
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  /* position: absolute; */
  /* background-color: red; */
  background: url("../assets/img/loginBg.jpeg");
  /* height: 100vh;
  width: 100vh; */

  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #fff;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  min-height: 700px;
  /*overflow: auto;*/
  overflow: visible;
  position: relative;
}
.mooctestlogo {
  background-image: url("../assets/img/mooctestlogo.png");
  background-size: cover;
  width: 91px;
  height: 100px;
  margin: 0 auto;
}
.registerCard {
  height: 400px;
  width: 400px;
  /* background-color: aqua; */
  margin: 100px auto;
}
</style>
